import type {ButtonProps, RadioProps} from '@yandex-delivery/blocks'
import {absurd} from '@yandex-delivery/utils'

import {appConfig, i18n} from 'src/shared/config'

import {CardErrorCode} from '../Card/api'

export function getUnauthorizedRadioProps(cardErrorCode: CardErrorCode): RadioProps<string> {
  if (cardErrorCode === CardErrorCode.UNAUTHORIZED) {
    return {
      onClick() {
        window.location.href = appConfig.getPassportUrl('/auth')
      },
    }
  }

  if (cardErrorCode === CardErrorCode.EMPTY_LOGIN) {
    return {
      onClick() {
        window.location.href = appConfig.getPassportUrl('/auth/complete')
      },
    }
  }

  if (cardErrorCode === CardErrorCode.EMPTY_PHONE) {
    return {
      onClick() {
        window.location.href = appConfig.getPassportUrl('/phoneconfirm')
      },
    }
  }

  absurd(cardErrorCode)
}

export function getUnauthorizedButtonProps(cardErrorCode: CardErrorCode): ButtonProps {
  if (cardErrorCode === CardErrorCode.UNAUTHORIZED) {
    return {
      onPress: undefined,
      children: i18n('order-form.payments-widget.card.unauthorized', 'Войти в Яндекс ID'),
      // @ts-expect-error TS2322: Type '"a"' is not assignable to type '"button"'.
      Component: 'a',
      href: appConfig.getPassportUrl('/auth'),
    }
  }

  if (cardErrorCode === CardErrorCode.EMPTY_LOGIN) {
    return {
      onPress: undefined,
      children: i18n('order-form.payments-widget.card.empty-login', 'Создать логин'),
      // @ts-expect-error TS2322: Type '"a"' is not assignable to type '"button"'.
      Component: 'a',
      href: appConfig.getPassportUrl('/auth/complete'),
    }
  }

  if (cardErrorCode === CardErrorCode.EMPTY_PHONE) {
    return {
      onPress: undefined,
      children: i18n('order-form.payments-widget.card.empty-phone', 'Привязать телефон'),
      // @ts-expect-error TS2322: Type '"a"' is not assignable to type '"button"'.
      Component: 'a',
      href: appConfig.getPassportUrl('/phoneconfirm'),
    }
  }

  absurd(cardErrorCode)
}
